import React from 'react';
import { EditIcon } from '../../../../assets/icons';
import { getLocalStorageItem } from '../../../../utils';

export const ActionBox1 = ({ data, setPopUp, setPopUpData }) => {
  const vendorType = getLocalStorageItem('vendor_type');
  const isDyeingAndNotReady = vendorType === 'dyeing' && data?.ready_status === 'Not Ready';

  return (
    <div className="td-num">
      <>
        {data.state !== 'done' &&
        data.state !== 'cancel' &&
        data.state !== 'cancelled' &&
        (data.producing_quantity < data.demand_quantity ) ? (
          isDyeingAndNotReady ? (
            <>-</>
          ) : (
            <EditIcon
              onClick={(e) => {
                e.stopPropagation();
                setPopUp(true);
                setPopUpData(data);
              }}
            />
          )
        ) : (
          <>-</>
        )}
      </>
    </div>
  );
};
